import { Rule } from '../RuleBox'

const fhrRules: Array<Rule> = [
  {
    details:
      'Geotoken Zero is the parent of the first Geotokens.  This geotoken encompasses the entire world, and participates in the rules the same as every other geotoken.',
    reason: 'We wanted to provide value for our FHR token holders based on their support for the development of XYO.',
    summary: 'Geotoken Zero',
  },
  {
    details: 'It has not been determined exactly how the XYO tokens that gather in Geotoken Zero will be released to FHR memebers or when.',
    reason:
      'With the combination of high gas prices and verification processes, we did not want to hold up the launch of XYO World by waiting to finalize this.  The tokens in Geotoken Zero will only be released to FHR members. In the case that there is a technical reason that these tokens cannot be released, they will be left in Geotoken Zero forever, or burned.',
    summary: 'Distribution of Geotoken Zero Tokens',
  },
]

export default fhrRules
